import { render, staticRenderFns } from "./OverallLayout.vue?vue&type=template&id=423b6989&scoped=true"
import script from "./OverallLayout.vue?vue&type=script&lang=js"
export * from "./OverallLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423b6989",
  null
  
)

export default component.exports